import React from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import Link from 'Pure/Link';
import { URL } from 'Shared/Routes';
import DiscountCodeForm from 'Components/Forms/Models/DiscountCode/DiscountCodeForm';
export default function NewDiscountCodePage(props) {
  return /*#__PURE__*/React.createElement(Layout, {
    page_title: "Nouveau code promo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "o-content"
  }, /*#__PURE__*/React.createElement(Button, {
    component: Link,
    href: URL('DiscountCodesDashboard'),
    className: "u-margin-bottom-15"
  }, '<', " Retour aux codes promo"), /*#__PURE__*/React.createElement(DiscountCodeForm, {
    type: "creation"
  })));
}
